import { Link } from "react-router-dom";
import { Mail, Phone, Instagram, Facebook, Linkedin } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { QuoteButton } from "@/components/QuoteButton";

export function Footer() {
  const { content } = useContent();
  const c = content?.contact || {};
  const s = content?.social || {};

  return (
    <footer data-testid="site-footer" className="bg-[#2C2C2C] text-[#FAF6EF]">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="inline-block rounded-xl bg-[#FAF6EF] p-3">
              <img src="/afroregal-logo.webp" alt="Afro Regal" className="h-16 w-auto" />
            </div>
            <p className="mt-4 text-sm tracking-[0.22em] uppercase text-[#C9A84C]">
              Créateurs de beaux moments
            </p>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#FAF6EF]/70">
              Traiteur événementiel, cheffe à domicile et coordination événementielle.
            </p>
            <div className="mt-6 flex gap-3">
              {s.instagram && (
                <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="social-instagram" className="rounded-full border border-white/20 p-2 transition-colors hover:border-[#C9A84C] hover:text-[#C9A84C]"><Instagram size={18} /></a>
              )}
              {s.facebook && (
                <a href={s.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="social-facebook" className="rounded-full border border-white/20 p-2 transition-colors hover:border-[#C9A84C] hover:text-[#C9A84C]"><Facebook size={18} /></a>
              )}
              {s.linkedin && (
                <a href={s.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="social-linkedin" className="rounded-full border border-white/20 p-2 transition-colors hover:border-[#C9A84C] hover:text-[#C9A84C]"><Linkedin size={18} /></a>
              )}
            </div>
          </div>

          <div>
            <h4 className="font-serif text-xl text-white">Nos services</h4>
            <ul className="mt-5 space-y-3 text-sm text-[#FAF6EF]/70">
              <li><Link to="/traiteur" className="hover:text-[#C9A84C]">Traiteur événementiel</Link></li>
              <li><Link to="/mariages" className="hover:text-[#C9A84C]" data-testid="footer-mariages">Mariages & cérémonies</Link></li>
              <li><Link to="/menus" className="hover:text-[#C9A84C]">Nos menus & cartes</Link></li>
              <li><Link to="/cheffe-a-domicile" className="hover:text-[#C9A84C]">Cheffe à domicile</Link></li>
              <li><Link to="/coordination" className="hover:text-[#C9A84C]">Coordination événementielle</Link></li>
              <li><Link to="/realisations" className="hover:text-[#C9A84C]">Nos réalisations</Link></li>
              <li><Link to="/blog" className="hover:text-[#C9A84C]">Le Journal Afro Regal</Link></li>
              <li><Link to="/a-propos" className="hover:text-[#C9A84C]">À propos</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-xl text-white">Contact</h4>
            <ul className="mt-5 space-y-3 text-sm text-[#FAF6EF]/70">
              <li>
                <a href={`mailto:${c.email_principal || "contact@afroregal.fr"}`} data-testid="footer-email-principal" className="inline-flex items-center gap-2 hover:text-[#C9A84C]">
                  <Mail size={15} /> {c.email_principal || "contact@afroregal.fr"}
                </a>
              </li>
              <li>
                <a href={`mailto:${c.email_secondaire || "afro.regal@gmail.com"}`} data-testid="footer-email-secondaire" className="inline-flex items-center gap-2 hover:text-[#C9A84C]">
                  <Mail size={15} /> {c.email_secondaire || "afro.regal@gmail.com"}
                </a>
              </li>
              <li>
                <a href={`tel:${(c.phone || "06 41 28 33 85").replace(/[^\d+]/g, "")}`} data-testid="footer-phone" className="inline-flex items-center gap-2 hover:text-[#C9A84C]">
                  <Phone size={15} /> {c.phone || "06 41 28 33 85"}
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <QuoteButton variant="gold" testId="footer-quote-btn" />
            </div>
          </div>

          <div>
            <h4 className="font-serif text-xl text-white">Informations</h4>
            <ul className="mt-5 space-y-3 text-sm text-[#FAF6EF]/70">
              <li><Link to="/mentions-legales" className="hover:text-[#C9A84C]">Mentions légales</Link></li>
              <li><Link to="/confidentialite" className="hover:text-[#C9A84C]">Politique de confidentialité</Link></li>
              <li><Link to="/cgv-traiteur" className="hover:text-[#C9A84C]">CGV Traiteur</Link></li>
              <li><Link to="/cgv-coordination" className="hover:text-[#C9A84C]">CGV Coordination événementielle</Link></li>
              <li><Link to="/cgv-cheffe" className="hover:text-[#C9A84C]">Conditions Cheffe à domicile</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-[#FAF6EF]/50 md:flex-row">
          <p>© {new Date().getFullYear()} Afro Regal — SAS. Tous droits réservés.</p>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#C9A84C]">Administration</Link>
        </div>
      </div>
    </footer>
  );
}
